import { makeAutoObservable } from "mobx"

export default class MoreMenuStore {
   sp
   callback
   open

   constructor(sp: { anchor: HTMLElement | null, callback?: (id: string | undefined) => void }) {
      makeAutoObservable(this)
      this.sp = sp
      this.callback = sp.callback
      this.open = Boolean(this.sp.anchor)
   }

   openMenu = (event: React.MouseEvent<HTMLElement>) => {
      this.sp.anchor = event.currentTarget
      this.open = true
   }

   closeMenu = async (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLInputElement>) => {
      const id = event.currentTarget.getAttribute("data-id") || undefined
      const closesMenu = !event.currentTarget.getAttribute("data-prevent-menu-close")
      this.open = !closesMenu
      if (this.callback) {
         this.callback(id)
      }
   }
}
